import * as $ from "jquery";
import printJS from "print-js";
import * as qz from "qz-tray";
import config from "./config";
import Swal from "sweetalert2";
import moment from "moment";
import axios from "axios";

export const removeEmptyFields = (obj) => {
  return Object.fromEntries(
    Object.entries(obj).filter(
      ([, value]) => value !== "" && value !== null && value !== undefined,
    ),
  );
};

export const inputOnlyNumber = (e) => {
  let allowKeys = [
    "Tab",
    "Backspace",
    "Delete",
    "Enter",
    "ArrowUp",
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight",
  ];
  if (e.ctrlKey || e.metaKey) return;
  if (
    !(
      $.isNumeric(e.key) ||
      e.key === "." ||
      e.key === "-" ||
      allowKeys.includes(e.key)
    )
  ) {
    e.preventDefault();
    return;
  }

  const inputValue = e.target.value;
  if (e.key === "-") {
    if (inputValue.length > 0 || inputValue.includes("-")) {
      e.preventDefault();
    }
    return;
  }
  if (e.target.getAttribute("name") == "qty") {
    if (e.target.value.toString().includes(".")) {
      let digitPlaces = e.target.value.toString().split(".")[0].length;
      let decimalPlaces = e.target.value.toString().split(".")[1].length;
      if (digitPlaces > 4 && !allowKeys.includes(e.key)) e.preventDefault();
      if (decimalPlaces > 1 && !allowKeys.includes(e.key)) e.preventDefault();
    } else {
      let digitPlaces = e.target.value.toString().length;
      if (digitPlaces > 4 && !allowKeys.includes(e.key)) e.preventDefault();
    }
  } else if (e.target.getAttribute("name") == "base_price") {
    if (e.target.value.toString().includes(".")) {
      let digitPlaces = e.target.value.toString().split(".")[0].length;
      let decimalPlaces = e.target.value.toString().split(".")[1].length;
      if (digitPlaces > 11 && !allowKeys.includes(e.key)) e.preventDefault();
      if (decimalPlaces > 3 && !allowKeys.includes(e.key)) e.preventDefault();
    } else {
      let digitPlaces = e.target.value.toString().length;
      if (digitPlaces > 11 && !allowKeys.includes(e.key)) e.preventDefault();
    }
  } else if (e.target.getAttribute("name") == "selling_price") {
    if (e.target.value.toString().includes(".")) {
      let digitPlaces = e.target.value.toString().split(".")[0].length;
      let decimalPlaces = e.target.value.toString().split(".")[1].length;
      if (digitPlaces > 8 && !allowKeys.includes(e.key)) e.preventDefault();
      if (decimalPlaces > 3 && !allowKeys.includes(e.key)) e.preventDefault();
    } else {
      let digitPlaces = e.target.value.toString().length;
      if (digitPlaces > 8 && !allowKeys.includes(e.key)) e.preventDefault();
    }
  }

  // if (
  //   !(
  //     $.isNumeric(e.key) ||
  //     e.key === "." ||
  //     e.key === "-" ||
  //     allowKeys.includes(e.key)
  //   )
  // )
  //   e.preventDefault();
};

export const inputNumber = (e) => {
  let allowKeys = [
    "Tab",
    "Backspace",
    "Delete",
    "Enter",
    "ArrowUp",
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight",
  ];
  let pattern = /[0-9]/;
  if (e.ctrlKey || e.metaKey) return;
  if (!(pattern.test(e.key) || allowKeys.includes(e.key))) e.preventDefault();
};
export const inputfourDigitDeciaml = (e) => {
  const allowKeys = [
    "Tab",
    "Backspace",
    "Delete",
    "Enter",
    "ArrowUp",
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight",
  ];

  // Allow navigation keys
  if (allowKeys.includes(e.key)) return;

  // Get the current value and caret position
  const { value, selectionStart } = e.target;

  // Define regex patterns
  const isDigit = /[0-9]/.test(e.key);
  const hasDecimal = value.includes(".");
  const decimalIndex = value.indexOf(".");

  // Prevent more than 4 digits before the decimal
  if (!hasDecimal && isDigit && value.length >= 4) {
    e.preventDefault();
    return;
  }

  // Allow only two digits after the decimal
  if (
    hasDecimal &&
    isDigit &&
    selectionStart > decimalIndex &&
    value.length - decimalIndex > 2
  ) {
    e.preventDefault();
    return;
  }

  // Only allow one decimal point
  if (e.key === "." && hasDecimal) {
    e.preventDefault();
    return;
  }

  // Allow typing a decimal point after up to 4 digits
  if (!isDigit && e.key !== ".") {
    e.preventDefault();
  }
};
export const inputfiveDigitDeciaml = (e) => {
  const allowKeys = [
    "Tab",
    "Backspace",
    "Delete",
    "Enter",
    "ArrowUp",
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight",
  ];

  // Allow navigation keys
  if (allowKeys.includes(e.key)) return;

  // Get the current value and caret position
  const { value, selectionStart } = e.target;

  // Define regex patterns
  const isDigit = /[0-9]/.test(e.key);
  const hasDecimal = value.includes(".");
  const decimalIndex = value.indexOf(".");

  // Prevent more than 4 digits before the decimal
  if (!hasDecimal && isDigit && value.length >= 5) {
    e.preventDefault();
    return;
  }

  // Allow only two digits after the decimal
  if (
    hasDecimal &&
    isDigit &&
    selectionStart > decimalIndex &&
    value.length - decimalIndex > 2
  ) {
    e.preventDefault();
    return;
  }

  // Only allow one decimal point
  if (e.key === "." && hasDecimal) {
    e.preventDefault();
    return;
  }

  // Allow typing a decimal point after up to 4 digits
  if (!isDigit && e.key !== ".") {
    e.preventDefault();
  }
};
export const inputTenDigitDecimal = (e) => {
  const allowKeys = [
    "Tab",
    "Backspace",
    "Delete",
    "Enter",
    "ArrowUp",
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight",
  ];

  // Allow navigation keys
  if (allowKeys.includes(e.key)) return;

  // Get the current value and caret position
  const { value, selectionStart } = e.target;

  // Define regex patterns
  const isDigit = /[0-9]/.test(e.key);
  const hasDecimal = value.includes(".");
  const decimalIndex = value.indexOf(".");

  // Prevent more than 10 digits before the decimal
  if (!hasDecimal && isDigit && value.length >= 10 && e.key !== ".") {
    e.preventDefault();
    return;
  }

  // Allow only six digits after the decimal
  if (
    hasDecimal &&
    isDigit &&
    selectionStart > decimalIndex &&
    value.length - decimalIndex > 6
  ) {
    e.preventDefault();
    return;
  }

  // Only allow one decimal point
  if (e.key === "." && hasDecimal) {
    e.preventDefault();
    return;
  }

  // Allow typing a decimal point or digits
  if (!isDigit && e.key !== ".") {
    e.preventDefault();
  }
};

export const inputAlphanum = (e) => {
  let allowKeys = [
    "Tab",
    "Backspace",
    "Delete",
    "Enter",
    "ArrowUp",
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight",
  ];
  let pattern = /[0-9A-Za-z \@\#\$\&\-\_\.\,\:\'\\\/\*]/;
  if (!(pattern.test(e.key) || allowKeys.includes(e.key))) e.preventDefault();
};
export const inputAlphanumeric = (e) => {
  let allowKeys = [
    "Tab",
    "Backspace",
    "Delete",
    "Enter",
    "ArrowUp",
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight",
  ];
  let pattern = /[0-9A-Za-z \@\#\$\&\-\_\.\,\:\'\\\/\*]/;
  if (!(pattern.test(e.key) || allowKeys.includes(e.key))) e.preventDefault();
};
export const inputAlphanumSpe = (e) => {
  let allowKeys = [
    "Tab",
    "Backspace",
    "Delete",
    "Enter",
    "ArrowUp",
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight",
  ];
  let pattern = /^[a-zA-Z0-9 \ \:\'\&\#\$\*\@\/\,\-\_\.\(\)\{\}\[\]\']+$/;

  if (!(pattern.test(e.key) || allowKeys.includes(e.key))) e.preventDefault();
};
export const inputChangeFocus = (e, next, prev) => {
  if ($.isNumeric(e.key)) {
    $(`#${next}`).focus();
  }
  if (e.key == "Backspace") {
    $(`#${prev}`).focus();
  }
};

export const capitalize = (text) => {
  return text.charAt(0).toUpperCase() + text.slice(1);
};

export const printPrinter = (
  hdr_id,
  extra = "",
  setShowPageLoader,
  compName,
) => {
  console.log("compNamecompName", compName)
  setShowPageLoader(() => "Preparing to Print Document...");
  let printerName = localStorage.getItem("defaultPrinter");
  let timestamp = new Date().getTime();
  
  if (printerName != "") {
      //  let pdfUrl = `${config.apiUrl}/iframe/${hdr_id}${extra}.pdf`;
    let pdfUrl = `${config.apiUrl}/iframe/${hdr_id}${extra}.pdf?_=${timestamp}`;
    qz.websocket
      .connect()
      .then(() => {
        let config = qz.configs.create(printerName);
        return qz.print(config, [
          {
            type: "pixel",
            format: "pdf",
            flavor: "file",
            data: pdfUrl,
          },
        ]);
      })
      .then(() => {
        setTimeout(() => {
          setShowPageLoader(() => false);
        }, 2000);
        return qz.websocket.disconnect();
      })
      .catch((err) => {
        // printJS(pdfUrl);
        printJS({
          printable: pdfUrl,
          type: "pdf",
          onError: (error, xmlHttpRequest) => {
            alert("Error while printing...");
          },
        });
        setTimeout(() => {
          setShowPageLoader(() => false);
        }, 2000);
        return qz.websocket.disconnect();
      });
  } else {
      // let pdfUrl = `${config.apiUrl}/iframe/${hdr_id}${extra}.pdf`;
    let pdfUrl = `${config.apiUrl}/iframe/${hdr_id}${extra}.pdf?_=${timestamp}`;
    try {
      // printJS(pdfUrl);
      printJS({
        printable: pdfUrl,
        type: "pdf",
        onError: (error, xmlHttpRequest) => {
          alert("Error while printing...");
        },
      });
      setTimeout(() => {
        setShowPageLoader(() => false);
      }, 2000);
    } catch (err) {
      Swal.fire("", err?.data?.message || err?.message || "Error while printing");
      setTimeout(() => {
        if (setShowPageLoader) setShowPageLoader(() => false);
      }, 2000);
    }
  }
};

export const printStockTransfer = async (
  stk_adj_id,
  arg2,
  arg3
) => {
  const setShowPageLoader = typeof arg2 === "function" ? arg2 : arg3;
  if (setShowPageLoader) setShowPageLoader(() => "Preparing to Print Document...");
  try {
    const token = JSON.parse(localStorage.getItem("inventory") || "{}")?.token;
    const response = await axios.post(
      `${config.apiUrl}/stockAdjustment/printStockTransfer`,
      {
        stk_adj_id: Number(stk_adj_id),
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: token ? `Bearer ${token}` : "",
        },
        responseType: "blob",
      }
    );

    let pdfDataUrl = null;
    const contentType = response.headers?.["content-type"] || "";

    if (
      contentType.includes("application/json") ||
      response.data?.type === "application/json"
    ) {
      const text = await response.data.text();
      const json = JSON.parse(text);
      if (json.status && json.status !== 200) {
        Swal.fire(
          "Error",
          json.message || json?.data?.message || "Failed to print",
          "error"
        );
        if (setShowPageLoader) setShowPageLoader(() => false);
        return;
      }
      const pdfTarget =
        json?.data?.url || json?.data?.pdf_url || json?.url || json?.pdf;
      if (pdfTarget) {
        pdfDataUrl = pdfTarget;
      } else if (json?.data?.base64 || json?.base64) {
        pdfDataUrl = `data:application/pdf;base64,${
          json?.data?.base64 || json?.base64
        }`;
      }
    } else {
      const blob = new Blob([response.data], { type: "application/pdf" });
      pdfDataUrl = window.URL.createObjectURL(blob);
    }

    if (!pdfDataUrl) {
      const blob = new Blob([response.data], { type: "application/pdf" });
      pdfDataUrl = window.URL.createObjectURL(blob);
    }

    let printerName = localStorage.getItem("defaultPrinter");
    if (printerName && printerName !== "" && window.qz) {
      try {
        await qz.websocket.connect();
        const qzConfig = qz.configs.create(printerName);
        await qz.print(qzConfig, [
          {
            type: "pixel",
            format: "pdf",
            flavor: "file",
            data: pdfDataUrl,
          },
        ]);
        await qz.websocket.disconnect();
      } catch (err) {
        printJS({
          printable: pdfDataUrl,
          type: "pdf",
          onError: () => {
            alert("Error while printing...");
          },
        });
      }
    } else {
      printJS({
        printable: pdfDataUrl,
        type: "pdf",
        onError: () => {
          alert("Error while printing...");
        },
      });
    }
  } catch (error) {
    console.error("Print Stock Transfer Error:", error);
    let errMsg = "Error while generating print document";
    if (error.response?.data) {
      if (error.response.data instanceof Blob) {
        try {
          const text = await error.response.data.text();
          const json = JSON.parse(text);
          errMsg = json?.message || json?.data?.message || errMsg;
        } catch (_) {}
      } else {
        errMsg =
          error.response.data?.message ||
          error.response.data?.data?.message ||
          errMsg;
      }
    }
    Swal.fire("Error", errMsg, "error");
  } finally {
    if (setShowPageLoader) {
      setTimeout(() => {
        setShowPageLoader(() => false);
      }, 1500);
    }
  }
};
export const millionComma = (value) => {
  let num = Number(value);

  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 4, // 👈 ye add karo
  }).format(num);
};
export const removeMillionComma = (value) => {
  let num = value ? `${value}`.replace(/\,/g, "") : 0;
  return Number(num);
};

export const userBackDate = () => {
  let localData = JSON.parse(localStorage.getItem("inventory")).userData;
  let backDays = localData.back_date == null ? 30 : localData.back_date;

  return moment().subtract(backDays, "days").format("YYYY-MM-DD");
};
let audioContext = null;

const getAudioContext = () => {
  if (!audioContext) {
    audioContext = new (window.AudioContext || window.webkitAudioContext)();
  }
  return audioContext;
};

const playSuccessSound = () => {
  const context = getAudioContext();
  const oscillator = context.createOscillator();
  const gainNode = context.createGain();

  oscillator.connect(gainNode);
  gainNode.connect(context.destination);

  oscillator.frequency.setValueAtTime(800, context.currentTime);
  oscillator.type = "sine";

  gainNode.gain.setValueAtTime(0.3, context.currentTime);
  gainNode.gain.exponentialRampToValueAtTime(
    0.01,
    context.currentTime + 0.3
  );

  oscillator.start();
  oscillator.stop(context.currentTime + 0.3);
};

const playErrorSound = () => {
  const context = getAudioContext();
  const oscillator = context.createOscillator();
  const gainNode = context.createGain();

  oscillator.connect(gainNode);
  gainNode.connect(context.destination);

  oscillator.frequency.setValueAtTime(300, context.currentTime);
  oscillator.type = "sawtooth";

  gainNode.gain.setValueAtTime(0.3, context.currentTime);
  gainNode.gain.exponentialRampToValueAtTime(
    0.01,
    context.currentTime + 0.5
  );

  oscillator.start();
  oscillator.stop(context.currentTime + 0.5);
};

export const playBarcodeSound = (success) => {
  try {
    if (success) {
      playSuccessSound();
    } else {
      playErrorSound();
    }
  } catch (e) {
    console.log("Sound play prevented", e);
  }
};

export const debounce = (func, delay) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
};

export const getFilteredStockInTypes = (typesList, userObj) => {

  if (!typesList) return [];
  const compId = userObj?.comp_id;
  const roleId = userObj?.role_id;
  if (compId === 2 || compId === 24 ) {
    if (roleId === 2) {
      return typesList.filter(item => item.value !== 1);
    } else {
      return typesList.filter(item => item.value === 1);
    }
  }
  return typesList;
};

export const isStockTransferOnly = (userObj) => {
  const compId = userObj?.comp_id;
  const roleId = userObj?.role_id;
  if (compId === 2 || compId === 24) {
    return roleId !== 2;
  }
  return false;
};

export const isStockAdjustmentOnly = (userObj) => {
  const compId = userObj?.comp_id;
  const roleId = userObj?.role_id;
  if (compId === 2 || compId === 24) {
    return roleId === 2;
  }
  return false;
};

export const isStockActionAllowed = (userObj, defaultAllowedRoles = [3, 8]) => {
  const compId = userObj?.comp_id;
  const roleId = userObj?.role_id;
  if (compId === 2 || compId === 24 ) {
    if (roleId === 2) return true;
  }
  return defaultAllowedRoles.includes(roleId);
};

export const isStockEditAllowed = (userObj, status, createdBy) => {
  if (!userObj || !userObj.role_id) return false;

  const compId = Number(userObj?.comp_id);
  const roleId = Number(userObj?.role_id);
  const userId = Number(userObj?.user_id);

  if (compId === 2 || compId === 24) {
    if (roleId === 2) {
      // if (status == 6) {
      //   return false;
      // }
      // if (status == 3 || status == 5 ||  status == 6) { 
      //   return Number(createdBy) === userId;
      // }
      return false;
    } else {
      return status == 3 || status == 5 || status == 2;
    }
  }

  return roleId !== 2 && (status == 3 || status == 5 || status == 2);
};

export const isStockBranchAllowed = (userObj, entryFromBranchId) => {
  const roleId = userObj?.role_id;
  if (roleId === 2) {
    return true;
  }
  return userObj?.branch_data?.[0]?.branch_id == entryFromBranchId;
};

export const isStockCancelAllowed = (userObj, entry) => {
  const compId = userObj?.comp_id;
  const roleId = userObj?.role_id;
  const status = entry?.is_active;
  const type = entry?.stk_adj_type;

  // Stock Transfers (type == 1) cannot be cancelled via this button
  // if (type == 1) {
  //   return false;
  // }

  // // If Admin in company 2, 24, 1
  // if ((compId === 2 || compId === 24 || compId === 1) && roleId === 2) {
  //   return status != 0; // Show Cancel if not already cancelled/rejected (status !== 0)
  // }

  // For non-admins or other companies
  if (!isStockActionAllowed(userObj)) {
    return false;
  }

  // Must match branch for non-admins
  const isBranchAllowed = isStockBranchAllowed(userObj, entry?.from_branch);
  if (!isBranchAllowed) {
    return false;
  }

  return status == 5 || status == 3;
};

export const showCreatedByName = (userObj) => {
  if (!userObj) return false;
  const compId = Number(userObj?.comp_id);
  return compId === 2 || compId === 24;
};